import {Loader} from "@googlemaps/js-api-loader";
import {getAppConfig} from '../config';


/**
 * replace all [data-community-map] elements with a Google map
 */
const setupCommunityMaps = () =>
{
	const mapElems  = document.querySelectorAll( '[data-community-map]' );
	const appConfig = getAppConfig();

	if (mapElems.length > 0) {

		const loader = new Loader( {
			apiKey:  appConfig.googleMapsApiKey,
			version: "weekly",
		} );

		loader.load().then( () =>
		{
			mapElems.forEach( mapElem =>
			{
				const zoom   = parseInt( mapElem.dataset.zoom, 10 ) || 4;
				const name   = mapElem.dataset.name;
				const lat    = parseFloat( mapElem.dataset.lat );
				const lng    = parseFloat( mapElem.dataset.lng );
				const coords = { lat: lat, lng: lng };

				const map = new google.maps.Map( mapElem, {
					zoom:   zoom,
					center: coords,
				} );

				new google.maps.Marker( {
					position: coords,
					map:      map,
					label:    {
						text:      name,
						className: 'community-map-marker-label',
					}
				} );
			} );
		} );
	}
};


/**
 *
 */
export default setupCommunityMaps;